import { render, staticRenderFns } from "./no-content.vue?vue&type=template&id=16f919a4&scoped=true&"
import script from "./no-content.vue?vue&type=script&lang=js&"
export * from "./no-content.vue?vue&type=script&lang=js&"
import style0 from "./no-content.vue?vue&type=style&index=0&id=16f919a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f919a4",
  null
  
)

export default component.exports